// The "rest row" of a multi-site day (Mehrbaustellenbuchung): at most one allocation
// is automatic and always carries whatever the other rows leave of the day, so a
// one-site day books itself and a second site only needs its own hours typed in.
//
// Shared with the mobile form (bau-app-mobile
// `src/components/timesheets/multiSiteAutoFill.ts`) — keep the two in step; their
// tests run the same table of cases.
//
// `targetMinutes` is what the sites have to cover: the net window minus any credited
// driving that sits inside it. `rowMinutes` holds one entry per allocation, `null` for
// a row whose hours are still blank.

// Minutes the row at `index` must hold for the day to balance, never below zero.
// Serves both the automatic row and "Rest übernehmen" on a manual one.
export function restMinutesFor({ targetMinutes, rowMinutes, index }) {
  const others = rowMinutes.reduce(
    (sum, minutes, i) => (i === index ? sum : sum + (minutes || 0)),
    0,
  )
  return Math.max(targetMinutes - others, 0)
}

// The row that takes over the automatic role: the last one whose hours are blank,
// or -1 when every row has been typed in.
export function nextAutoIndex(rowMinutes) {
  for (let i = rowMinutes.length - 1; i >= 0; i--) {
    if (rowMinutes[i] == null) return i
  }
  return -1
}

// "Gleichmäßig aufteilen": equal shares in `stepMinutes` steps; the last row takes
// the rounding difference so the day still balances to the minute.
export function evenSplitMinutes(targetMinutes, count, stepMinutes = 15) {
  if (count <= 0 || targetMinutes <= 0) return []

  const share = Math.floor(targetMinutes / count / stepMinutes) * stepMinutes
  const shares = Array.from({ length: count - 1 }, () => share)
  shares.push(targetMinutes - share * (count - 1))
  return shares
}
